import styled from "styled-components";

export const LmsAuthWrapper = styled.main`
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(50, 131, 116, 0.12), transparent 32rem),
    linear-gradient(135deg, #f8fbf7 0%, #eef6f3 48%, #f7f3ea 100%);
  color: #20332e;
  padding: 2rem;

  .lms-auth-back-link {
    position: fixed;
    top: 1.25rem;
    left: 1.25rem;
    z-index: 2;
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    border: 1px solid #d5dfdc;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.88);
    color: #2c443f;
    box-shadow: 0 10px 24px rgba(32, 51, 46, 0.08);
    font-weight: 800;
    letter-spacing: 0;
    text-decoration: none;
    padding: 0 0.85rem;
  }

  .lms-auth-back-link:hover {
    background: #ffffff;
    color: #1d6257;
  }

  .lms-auth-panel {
    width: min(1180px, 100%);
    min-height: calc(100vh - 4rem);
    margin: 0 auto;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(360px, 480px);
    align-items: center;
    gap: 3rem;
  }

  .lms-auth-story h1 {
    max-width: 12ch;
    margin: 0.75rem 0 1rem;
    color: #17342f;
    font-size: clamp(2.5rem, 6vw, 5.2rem);
    line-height: 0.95;
    text-transform: none;
    letter-spacing: 0;
  }

  .lms-auth-story p {
    color: #51645f;
    font-size: 1.08rem;
  }

  .lms-logo-container,
  .lms-sidebar-logo {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .lms-logo-text {
    color: #183b35;
    font-weight: 700;
    font-size: 1.25rem;
    letter-spacing: 0;
  }

  .eyebrow {
    margin: 0;
    color: #2e7d6f;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .lms-auth-card {
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(32, 51, 46, 0.08);
    border-radius: 8px;
    box-shadow: 0 24px 70px rgba(32, 51, 46, 0.12);
    padding: 2rem;
  }

  .lms-auth-heading h2 {
    margin: 0.25rem 0 0.5rem;
    color: #1e3833;
    font-size: 1.9rem;
    text-transform: none;
    letter-spacing: 0;
  }

  .lms-auth-heading p {
    margin: 0 0 1.25rem;
    color: #60716d;
    line-height: 1.55;
  }

  .lms-form {
    display: grid;
    gap: 1rem;
  }

  .lms-two-column {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
  }

  .lms-field {
    display: grid;
    gap: 0.35rem;
    color: #2c443f;
    font-weight: 700;
  }

  .lms-field span {
    font-size: 0.88rem;
  }

  .lms-field input,
  .lms-field select {
    width: 100%;
    min-height: 44px;
    border: 1px solid #d5dfdc;
    border-radius: 8px;
    background: #fbfdfc;
    color: #1e3833;
    padding: 0.7rem 0.8rem;
    font: inherit;
  }

  .lms-field input:focus,
  .lms-field select:focus {
    border-color: #2e7d6f;
    box-shadow: 0 0 0 3px rgba(46, 125, 111, 0.16);
    outline: none;
  }

  .lms-field-error {
    margin: -0.35rem 0 0;
    color: #a73535;
    font-size: 0.9rem;
    font-weight: 700;
  }

  .lms-role-toggle {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: #edf4f1;
    border: 1px solid #d7e4df;
    border-radius: 8px;
    padding: 0.25rem;
  }

  .lms-role-toggle button {
    min-height: 40px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: #49645e;
    cursor: pointer;
    font-weight: 700;
  }

  .lms-role-toggle button.active {
    background: #ffffff;
    color: #1d6257;
    box-shadow: 0 8px 20px rgba(32, 51, 46, 0.1);
  }

  .lms-submit,
  .lms-primary-action {
    min-height: 44px;
    border: 0;
    border-radius: 8px;
    background: #246b60;
    color: #ffffff;
    cursor: pointer;
    font-weight: 800;
    padding: 0.75rem 1rem;
  }

  .lms-submit:disabled {
    opacity: 0.65;
  }

  .lms-auth-switch {
    margin: 0;
    color: #60716d;
    text-align: center;
  }

  .lms-auth-switch a {
    color: #1d6257;
    font-weight: 800;
    letter-spacing: 0;
  }

  @media (max-width: 860px) {
    padding: 1rem;

    .lms-auth-back-link {
      position: static;
      margin-bottom: 1rem;
    }

    .lms-auth-panel {
      min-height: calc(100vh - 2rem);
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }

    .lms-auth-story h1 {
      max-width: 14ch;
      font-size: 2.6rem;
    }
  }

  @media (max-width: 560px) {
    .lms-auth-card {
      padding: 1.25rem;
    }

    .lms-two-column {
      grid-template-columns: 1fr;
    }
  }
`;
